import React from 'react'
import './loader.css'

const loader = () => {
  return (
    <figure>
    <div class="dot white"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
</figure>
  )
}

export default loader